<template>
  <div>
    <van-popup
      class="address-map-wrap"
      v-model="visibleMap"
      position="bottom"
      :style="{ width: '100%', height: '100%' }"
      :overlay="false">
      <div class="map-btn-group">
        <div class="btn cancel-btn" @click="handleCancelMap">取消</div>
        <div class="btn confirm-btn" @click="handleSureMap">确认</div>
      </div>
        <div class="amap-box">
          <iframe id="mapPage" width="100%" height="100%" frameborder=0 :src="map_src" class="amap-box-cont"></iframe>
        </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: 'mapComponents',
    props: {
      visibleMap: {
        type: Boolean,
        default: false,
      }
    },
    watch:{
      visibleMap(newVal, oldVal) {
        this.dialogVisible = newVal;
      }
    },
    data() {
      return {
        dialogVisible: false,
        map_src: 'https://mapapi.qq.com/web/mapComponents/locationPicker/v/index.html?search=1&type=1&key=Z2NBZ-5IP63-6W63V-3SHU2-6FWQQ-KIFFL&referer=location',
        form: {
          //省市区ID
          id_area: [
            0,
            0,
            0
          ],
          address: '',
          lng: '',
          lat: '',
        },
        map_data: {
          url: 'https://mapapi.qq.com/web/mapComponents/locationPicker/v/index.html?search=1&type=1&key=Z2NBZ-5IP63-6W63V-3SHU2-6FWQQ-KIFFL&referer=location',
          address: '',
          lng: '',
          lat: '',
        },
      }
    },
    created() {
      let that = this
      window.addEventListener('message', function(event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;
        // console.log(loc)
        if (loc && loc.module == 'locationPicker') { //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          that.map_data.address = loc.poiaddress
          that.map_data.lat = loc.latlng.lat
          that.map_data.lng = loc.latlng.lng
          // that.$emit('chooseMapPoint',that.map_data)
        } else {
          // that.$emit('chooseMapPoint','选择数据为空')
        }
      }, false);
    },
    methods: {
      //地图选点确定
      handleSureMap() {
        if(this.map_data.lat===''||this.map_data.lng==='') return this.Toast('请选择地址~');
        this.$emit('confirm', this.map_data)
      },
      // 取消
      handleCancelMap () {
        this.$emit('cancel')
      },
    }
  }
</script>

<style lang="scss" scoped>
  // @import '@/assets/styles/mixin.scss';
  .address-map-wrap{
    z-index: 2005 !important;
  }
  .map-header{
    width: 94%;
    position: absolute;
    top: 3rem;
    left: 3%;
    z-index: 3;
    .search-box{
      width: 100%;
    }
  }
  .search-box input {
      padding: 0 15px;
      width: 100%;
      height: 32px;
      line-height: 32px;
      color: #606266;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
  }

  .search-box input:focus {
      border-color: #409eff;
      outline: 0;
  }

  .search-box input::-webkit-input-placeholder {
      color: #c0c4cc;
  }
  .search-list{
    width: 100%;
    height: 200px;
    overflow-y: scroll;
    background: #fff;
    // border: 1px solid #ddd;
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 5;
    cursor: pointer;
    .item{
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #eee;
      font-size: 15px;
      color: #222;
      font-weight: 500;
      padding: 0 15px;
      box-sizing: border-box;
      overflow: hidden;
      position: relative;
      .icon-Selected-b{
        font-size: 20px;
        position: absolute;
        right: 15px;
        top: 0;
        display: none;
      }
      &:last-child{
        border-bottom: 0;
      }
      &-active{
        color: #47B6C7;
        .icon-Selected-b{
          color: #47B6C7;
          display: block;
        }
      }
    }
  }

  .tip-box {
      width: 100%;
      max-height: 580px;
      position: absolute;
      top: 35px;
      z-index: 10000;
      overflow-y: auto;
      background-color: #fff;
  }

  .amap-ui-poi-picker-sugg,
  .amap_lib_placeSearch {
      border: 1px solid #eee;
      border-radius: 4px;
  }
  .map-btn-group{
    width: 94%;
    height: 2rem;
    margin: 0 auto;
    @include flex(space-between);
    position: absolute;
    top: .5rem;
    left: 3%;
    z-index: 9;
    .btn{
      width: 4.4rem;
      height: 1.8rem;
      line-height: 1.8rem;
      font-size: .75rem;
      color: #222;
      text-align: center;
      border-radius: .5rem;
      cursor: pointer;
    }
    .cancel-btn{
      background: #eee;
    }
    .confirm-btn{
      background: $base-color;
      color: #fff;
    }
  }
  .amap-box {
    height: calc(100% - 2.6rem);
    margin-top: 2.4rem;
      &-cont{
        height: 100%;
      }
  }
</style>


// WEBPACK FOOTER //
// src/components/AMap.vue